const aaa = [
	{
		path: "shenpiList",
		component: () => import("@/views/caigou/shenpi/list.vue"),
		meta:{title:'审批',keepAlive:true},
	},
	{
		path: "weishenpiList",
		component: () => import("@/views/caigou/shenpi/weishenpi.vue"),
		meta:{title:'审批'},
	},
	{
		path: "yishenpiList",
		component: () => import("@/views/caigou/shenpi/yishenpiList.vue"),
		meta:{title:'审批'},
	},
	{
		path: "shenpibohui",
		component: () => import("@/views/caigou/shenpi/shenpibohui.vue"),
		meta:{title:'审批'},
	},
	{
		path: "caigouList",
		component: () => import("@/views/caigou/caigou/caigouList.vue"),
		meta:{title:'采购列表',keepAlive:true},
	},
	{
		path: "addcaigou",
		component: () => import("@/views/caigou/caigou/addCaigou.vue"),
		meta:{title:'采购列表'},
	},
	{
		path: "cgzDetail",
		component: () => import("@/views/caigou/caigou/cgzDetail.vue"),
		meta:{title:'采购列表'},
	},
	{
		path: "cgwcDetail",
		component: () => import("@/views/caigou/caigou/cgwcDetail.vue"),
		meta:{title:'采购列表'},
	},
	
	
	// {
	// 	path: "wuliaoShenpiList",
	// 	component: () => import("@/views/caigou/wuliao/zongcang/shenpiList.vue"),
	// 	meta:{title:'物料审批列表'},
	// },
	// {
	// 	path: "wuliaoCaigouList",
	// 	component: () => import("@/views/caigou/wuliao/zongcang/caigouList.vue"),
	// 	meta:{title:'物料采购列表'},
	// },
	// {
	// 	path: "shenpiDetail",
	// 	component: () => import("@/views/caigou/wuliao/zongcang/shenpiDetail.vue"),
	// 	meta:{title:'审批详情'},
	// },
	// {
	// 	path: "caigouDetail",
	// 	component: () => import("@/views/caigou/wuliao/zongcang/caigouDetail.vue"),
	// 	meta:{title:'采购详情'},
	// },
	// {
	// 	path: "xinjiancaigou",
	// 	component: () => import("@/views/caigou/wuliao/zongcang/xinjiancaigou.vue"),
	// 	meta:{title:'新建采购'},
	// },
	
	
]
export default aaa;